import Header from '../components/Header';
import Footer from '../components/Footer';
import ExtraContent from '../components/ExtraContent';
import '../styles/sideBySide.css';
import '../styles/CooperationPage.css';

const HomePage = () => {
  const contacts = [
    {
      type: "TELEGRAM",
      value: "@ilyashirko",
      href: "https://t.me/IlyaShirko"
    },
    {
      type: "VK",
      value: "@ilyashirko",
      href: "https://vk.com/ilyashirko"
    },
    {
      type: "MAIL",
      value: "ilyashirko@gmail.com",
      href: "mailto:ilyashirko@gmail.com"
    },
    
  ]

  return (
    // <div className="main">
    <div>
      <div id="mainContent" className="mainContent">
        <Header currentPage={"cooperation"} />
       
        <div className="content center" style={{ "width": "calc(100% - 60px)", "padding": "0 30px" }}>
          <div className="title"><strong>СОТРУДНИЧЕСТВО</strong></div>
          
          <p className="experienceResponsibilityItem">Я всегда в поиске нового опыта и если у вас есть интересный проект в котором вы видите мое участие - пришлите мне письмо на почту или сообщение в телеграм (лучше в телеграм) и мы обсудим возможные точки соприкосновения.</p>
          <div className="title"><strong>КОНТАКТЫ</strong></div>
          {contacts.map((contact) => (
            <div className="experienceResponsibilityItem">{contact.type}: <a href="${contact.href}"><strong>{contact.value}</strong></a></div>
          ))}
          <div className="title"><strong>ДО ВСТРЕЧИ!</strong></div>
        </div>

        <Footer />
      </div>
      
      <ExtraContent />
    </div>
  );
};

export default HomePage;